
const translations = {
  navItems: {
    home: 'Accueil',
    about: "À Propos",
    services: "Services",
    portfolio: "Portfolio",
    contact: "Contact",
    blog: 'Blog'
  },
  hero: {
    title: 'Je suis Moudondi Godfried',
    subtitle: "Création d'expériences numériques fluides",
    description: "Je suis un développeur front-end spécialisé dans la création de sites web et d'applications web modernes et réactifs qui privilégient l'expérience utilisateur et la performance.",
    contactButton: 'Contactez-moi',
    portfolioButton: 'Mon Portfolio',
    cta: "Contactez-moi"
  },
  about: {
    title: "À Propos de Moi",
    paragraph1: "Avec plus de 10 ans d'expérience en développement web, j'ai perfectionné mon métier pour créer des solutions numériques qui sont non seulement visuellement attrayantes, mais aussi hautement fonctionnelles et conviviales.",
    paragraph2: "Mon approche est centrée autour de trois principes fondamentaux : ",
    paragraph2FeatureBold1: "la simplicité",
    paragraph2FeatureBold2: "la performance",
    paragraph2FeatureBold3: "conception centrée sur l'utilisateur",
    paragraph3: "Je crois que les meilleurs sites web sont ceux qui communiquent clairement, se chargent rapidement et offrent une expérience intuitive aux utilisateurs.",
    paragraph4: "Mon expertise technique comprend les frameworks JavaScript modernes, les techniques de design responsive, et les stratégies d'optimisation qui garantissent que votre site web fonctionne parfaitement sur tous les appareils.",
    subtitle: "Ce qui distingue mon travail :",
    qualities: [
      "Attention méticuleuse aux détails",
      "Code propre et maintenable",
      "Accent sur l'accessibilité",
      "Optimisation des performances",
      "Approche responsive design",
      "Concentration sur les objectifs commerciaux"
    ]
  },
  services: {
    title: "Services que j'offre",
    items: [
      {
        title: "Design Web Responsive",
        description: "Création de sites web qui offrent une expérience de visualisation optimale sur tous les appareils, des ordinateurs de bureau aux téléphones mobiles."
      },
      {
        title: "Développement Front-End",
        description: "Construction d'interfaces utilisateur interactives et dynamiques à l'aide de frameworks et de bibliothèques modernes comme React, Vue ou Angular."
      },
      {
        title: "Conseil UI/UX",
        description: "Conseils pour des expériences et des interfaces utilisateur intuitives qui s'alignent avec l'identité de votre marque et répondent aux besoins des utilisateurs."
      },
      {
        title: "Stratégie Mobile-First",
        description: "Développement avec une approche mobile-first pour assurer la performance et l'utilisabilité sur les écrans plus petits."
      },
      {
        title: "Prototypage Interactif",
        description: "Création de prototypes interactifs pour tester les flux d'utilisateurs, les fonctionnalités et recueillir des commentaires avant l'implémentation finale."
      },
      {
        title: "Systèmes de Design",
        description: "Développement de systèmes de design complets qui assurent la cohérence et l'évolutivité de vos produits numériques."
      }
    ]
  },
  portfolio: {
    title: "Quelques Projets",
    subtitle: "Découvrez quelques-uns de mes projets récents et exemples de travaux",
    viewProject: "Voir le projet",
    items: [
      {
        title: "Maison d'hôte [Le Mans]",
        description: "Un site web pour une maison d'hôte à Le Mans, mettant en avant les chambres, les commodités et la réservation en ligne.",
        tags: ["HTML/CSS3", "ViteJs", "NodeJs"],
        thumbnail: "/assets/portfolio/pause-bonheur-portfolio.webp"
      },
      {
        title: "Therismos Global",
        description: "Un site web pour Therismos Global, présentant la gestion des événements, les archives de sermons et l'engagement communautaire.",
        tags: ["React", "Node.js", "Wordpress", "MysQL"],
        thumbnail: "/assets/portfolio/therismos-global-portfolio.webp"
      },
      {
        title: "Tile Crack",
        description: "Une application mobile qui permet de aux joueurs de savoir si un mot est valide ou non dans le jeu de Scrabble.",
        tags: ["React Native", "NodeJs", "Express", "MongoDB"],
        thumbnail: "/assets/portfolio/tile-crack-portfolio.webp"

      }
    ]
  },
  contact: {
    title: "Contactez-moi",
    subtitle: "Vous avez un projet en tête ou vous souhaitez discuter d'opportunités ? N'hésitez pas à me contacter.",
    name: "Nom",
    email: "Email",
    message: "Message",
    send: "Envoyer le message",
    success: "Votre message a été envoyé avec succès !",
    error: "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer.",
    emailLabel: 'Email',
    phoneLabel: 'Téléphone',
    locationLabel: 'Localisation',
    connectOnline: 'Se connecter en ligne',
    emailAddress: 'impelatek@gmail.com',
    phoneNumber: '+1 (123) 456-7890',
    location: 'Paris, France'
  },
  footer: {
    copyright: "© {{year}} Impelatek. Tous droits réservés.",
    developper: 'Developpeur'
  },
  cookies: {
    banner: {
      title: "Cookies & Confidentialité",
      description: "Nous utilisons des cookies pour améliorer votre expérience. Vous pouvez personnaliser vos préférences.",
      acceptAll: "Accepter tout",
      acceptNecessary: "Nécessaires uniquement",
      customize: "Personnaliser"
    },
    modal: {
      title: "Paramètres des cookies",
      description: "Nous respectons votre vie privée. Choisissez les types de cookies que vous autorisez. Vous pouvez modifier ces paramètres à tout moment.",
      savePreferences: "Sauvegarder les préférences",
      acceptAll: "Accepter tout",
      acceptNecessary: "Nécessaires uniquement",
      notice: "En continuant à utiliser ce site, vous acceptez notre utilisation des cookies conformément à notre politique de confidentialité."
    },
    categories: {
      necessary: {
        title: "Cookies nécessaires",
        description: "Ces cookies sont essentiels au fonctionnement du site web et ne peuvent pas être désactivés.",
        required: "Requis",
        alwaysActive: "Toujours actif"
      },
      analytics: {
        title: "Cookies d'analyse",
        description: "Ces cookies nous aident à comprendre comment les visiteurs interagissent avec le site web."
      },
      marketing: {
        title: "Cookies marketing",
        description: "Ces cookies sont utilisés pour personnaliser les publicités et mesurer leur efficacité."
      },
      preferences: {
        title: "Cookies de préférences",
        description: "Ces cookies nous permettent de mémoriser vos préférences et de personnaliser votre expérience."
      }
    },
    settings: {
      title: "Paramètres des cookies",
      lastModified: "Dernière modification :",
      expiryNotice: "Ces paramètres sont sauvegardés localement et expireront après 1 an.",
      aboutCookies: "À propos des cookies",
      aboutDescription: "Les cookies sont de petits fichiers texte stockés sur votre appareil lors de votre visite sur notre site. Ils nous aident à améliorer votre expérience et à analyser l'utilisation du site.",
      allowed: "Autorisé",
      blocked: "Bloqué",
      enable: "Activer",
      disable: "Désactiver"
    }
  }
};

export default translations;
